import React, { Component } from 'react'

class InputProps {
    name?: string;
    value?: string;
    label?: string;
    type?: string;
    errorMessage?: string;
    placeholder?: string;
    disabled?: boolean;
    onChange?: (value: string, name?: string) => void;
}

class InputState { }

class Input extends Component<InputProps, InputState> {

    private handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (this.props.onChange) {
            this.props.onChange(e.target.value, this.props.name);
        }
    }

    render() {
        const name = this.props.name || '';
        const value = this.props.value || '';
        const type = this.props.type || 'text';
        const placeholder = this.props.placeholder || '';
        const disabled = !!this.props.disabled;
        const id = Math.random().toString(36).substring(2);
        let label = <></>;

        if (this.props.label) {
            label = <label htmlFor={id} className={"label" + (this.props.errorMessage ? " is-danger" : "")}>{this.props.label}</label>;
        }

        return (
            <div className="field">
                {label}
                <div className="control">
                    <input className={"input" + (this.props.errorMessage ? " is-danger" : "")}
                        id={id}
                        name={name}
                        type={type}
                        placeholder={placeholder}
                        disabled={disabled}
                        value={value}
                        onChange={this.handleInputChange} />
                </div>
                {
                    this.props.errorMessage && <p className="help is-danger">{this.props.errorMessage}</p>
                }
            </div>
        );
    }
}

export default Input;
